// extracted by mini-css-extract-plugin
module.exports = {"loom-preview":"LoomPreview_loom-preview__AlccZ","loom-preview__iframe":"LoomPreview_loom-preview__iframe___tBH7"};